/**
* DevExpress HTML/JS Reporting (common\utils\_locker.js)
* Version:  23.2.13
* Build date: Apr 29, 2025
* Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
export class Locker {
    constructor() {
        this.lock = (action) => {
            if (!this.isUpdate) {
                this.isUpdate = true;
                action();
                this.isUpdate = false;
            }
        };
        this.isUpdate = false;
    }
}
